import { isInIframe } from '../../modules/_core/utils/app-utils';
export var parseUrl = function (url, key) {
    var out = {
        protocol: '',
        hostname: '',
        port: '',
        pathname: '',
        search: '',
        hash: '', // => "#hash"
    };
    var parser = document.createElement('a');
    parser.href = url || window.location.href;
    Object.keys(out).forEach(function (k) {
        out[k] = parser[k] || '';
    });
    return key ? out[key] : out;
};
export var getSearchVariable = function (variable, searchString) {
    if (!variable)
        return null;
    searchString = searchString || window.location.search;
    var urlParams = new URLSearchParams(searchString);
    return urlParams.get(variable);
};
/**
 * Returns url get parameter value from either iframe url, or regular url
 *
 * @param parameterName
 */
export var getUrlParameter = function (parameterName) {
    if (isInIframe()) {
        var urlParent = void 0;
        var urlIframe = void 0;
        var urlParentRaw = getSearchVariable('parent');
        if (urlParentRaw) {
            urlParent = decodeURIComponent(urlParentRaw);
        }
        else {
            // console.error('iframe without parent parameter', window.location.href);
        }
        urlIframe = window.location.href;
        // check both urls, favour iframe url
        var searchStringParent = parseUrl(urlParent).search;
        var searchStringIframe = parseUrl(urlIframe).search;
        var dataParent = getSearchVariable(parameterName, searchStringParent);
        var dataIframe = getSearchVariable(parameterName, searchStringIframe);
        return dataIframe || dataParent;
    }
    else {
        // check just one url
        var parsedUrl = parseUrl(window.location.href);
        var searchString = parsedUrl.search;
        var data = getSearchVariable(parameterName, searchString);
        return data;
    }
};
export var isGetParameterTruly = function (parameterName) {
    if (parameterName === void 0) { parameterName = ''; }
    if (!parameterName)
        return false;
    var value = getUrlParameter(parameterName);
    return value === 'true' || value === '1' || value === 'yes' || value === 'on';
};
